import { Flex, Text } from '@applyboard/crystal-ui';

import { PageHeader } from '../../../components/PageHeader';
import {
  ProgramFilter,
  IntakeTermFilter,
  CampusesFilter,
  AgencyFilter,
  NationalityFilter,
  ApplicationStats,
  FilterSummary,
} from '../components';

export function TabletLayout() {
  return (
    <Flex p={10} gap={3} direction="column">
      <PageHeader title="Application Reports" />
      <Text variant="headlineS">Report filters</Text>
      <Flex gap={2} justify="start" align="start" wrap>
        <Filter as={<ProgramFilter />} width="150px" />
        <Filter as={<IntakeTermFilter />} width="150px" />
        <Filter as={<CampusesFilter />} width="150px" />
        <Filter as={<AgencyFilter />} width="150px" />
        <Filter as={<NationalityFilter />} width="150px" />
      </Flex>
      <FilterSummary />
      <Flex pt={4}>
        <ApplicationStats />
      </Flex>
    </Flex>
  );
}

function Filter(props: { as: React.ReactNode; width: string }) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
